const BASE = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_API_URL || 'http://localhost:5001');

function getToken() {
  return localStorage.getItem('admin_token');
}

async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = { ...options.headers };

  if (token) headers['Authorization'] = `Bearer ${token}`;

  // FormData ise Content-Type'ı browser ayarlasın
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(`${BASE}${path}`, { ...options, headers });
  const data = await res.json().catch(() => ({ success: false, message: 'Sunucudan geçersiz yanıt alındı.' }));

  if (!res.ok) {
    const err = new Error(data.message || 'Bir hata oluştu.');
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export const api = {
  get: (path) => apiFetch(path),
  post: (path, body) => apiFetch(path, { method: 'POST', body: body instanceof FormData ? body : JSON.stringify(body) }),
  put: (path, body) => apiFetch(path, { method: 'PUT', body: body instanceof FormData ? body : JSON.stringify(body) }),
  delete: (path) => apiFetch(path, { method: 'DELETE' }),
};

export const API_BASE = BASE;

/**
 * API'de kayıtlı /uploads/... için <img src>.
 * Development: göreli yol + package.json "proxy" → istek 3000 üzerinden 5001'e gider (aynı origin).
 * Production: tam URL (CDN/ayrı host için).
 */
export function mediaSrc(src) {
  if (src == null || src === '') return '';
  if (typeof src !== 'string') return '';
  if (!src.startsWith('/uploads')) return src;
  if (process.env.NODE_ENV === 'development') return src;
  return `${BASE}${src}`;
}
